module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/sp/outer_link/banner3-3c1af15b6d1242bc0a67ccf2a5412663.png";